var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { CountDownTimer, TimerThemes } from '@sales/countdown-timer';
import { IconSvg } from '@idp/duc/components';
import { Button } from '@idp/ui-components';
import { CMS } from '@idp/cms-integration';
import { CartCms } from '@idse/cart-ui/cms/Cart.cms';
import * as cartUiUtils from '@idse/cart-ui/utils/UtilityFunctions';
import * as cartUtils from '@idse/cart-ui/utils/CartUtilFunctions';
import getTestId from '@idp/ui-components/utils';
import { StateProvider } from '../../services/state-provider';
import CheckoutApi from '@idse/cart-ui/api/Api';
import ReportingService, { PageUrls } from '@idse/cart-ui/api/ReportingService';
import * as styles from './Cart.container.scss';
var CartCheckoutCountDownTimer = /** @class */ (function (_super) {
    __extends(CartCheckoutCountDownTimer, _super);
    function CartCheckoutCountDownTimer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportingService = new ReportingService();
        _this.checkoutApi = new CheckoutApi();
        _this.cartCheckoutCMS = CMS.get(new CartCms(), 'cartcheckout');
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.countDownTime = 0;
        return _this;
    }
    CartCheckoutCountDownTimer.prototype.render = function () {
        return (this.renderCountDownTimer());
    };
    CartCheckoutCountDownTimer.prototype.renderCountDownTimer = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var sisfoOrderCMS = ((_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.common) === null || _c === void 0 ? void 0 : _c.sisfoOrder) ? this.cartCheckoutCMS.content.common.sisfoOrder : null;
        var isPersistantCart = cartUtils.isPersistedCart();
        var isLoginRequired = cartUiUtils.isLoginRequiredonCart();
        var redirectionURL = cartUiUtils.getauthenticatedPersistantLoginURL();
        var isPreOrder = cartUtils.isAtleastOneLineLevelPreOrderIndicator();
        if (cartUiUtils.isUPOrAALFlow() && cartUtils.isPrePreOrder() && this.countDownTime === 0) {
            this.checkIntervals();
            this.countDownTime++;
            var headingCmsText = isPersistantCart ? sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderHeadingReturnToCart : sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderHeading;
            var eyebrowCmsText = isPersistantCart ? sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderCountDownReturnToCart : sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderCountDown;
            var preOrderEmailMessage = (_d = sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderEmail) === null || _d === void 0 ? void 0 : _d.replace('(0)', (_e = sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderBeginDate) === null || _e === void 0 ? void 0 : _e.toString());
            return (React.createElement(React.Fragment, null,
                !isPreOrder &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.countdownTimerPpo },
                            React.createElement("div", { className: styles.countdownTimerDivPpo },
                                React.createElement(CountDownTimer, { endtime: sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderEndTime, fallbackText: sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderFallBackText, subHeading: sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderSubHeading, heading: headingCmsText, eyebrowText: eyebrowCmsText, description: sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderDescription, theme: TimerThemes.LightBlue })))),
                isPreOrder &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.countdownTimerPoContainer },
                            React.createElement("div", { className: styles.countdownTimerPo },
                                React.createElement(IconSvg, { className: styles.countdownTimerIcon, size: 32, svgNodeStr: cartUiUtils.GET_ICON_SVG.TIMER }),
                                React.createElement("span", { className: styles.countdownTimerPoHeading }, sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderFallBackText)))),
                !(isPreOrder && !isLoginRequired) &&
                    React.createElement("div", { className: styles.countdownMessageContainer },
                        React.createElement("div", { className: styles.countdownMessage },
                            !isPersistantCart && !isLoginRequired && !isPreOrder &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: styles.countdownMessageDesc }, preOrderEmailMessage)),
                            isLoginRequired && !isPreOrder &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", null,
                                        React.createElement("span", { className: styles.countdownMessageDesc }, sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderEarlySignIn)),
                                    React.createElement(Button, { testId: getTestId('Link', 'LOGIN_LINK'), data: { text: 'Sign in' }, options: { className: styles.countdownMessageLoginBtn }, events: {
                                            onClick: function () {
                                                _this.loginLinkClicked(redirectionURL);
                                            },
                                        } })),
                            isPersistantCart && !isLoginRequired && !isPreOrder &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", null,
                                        React.createElement("span", null,
                                            " ", sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 :
                                            sisfoOrderCMS.preOrderEarlyCount))),
                            isPreOrder && isLoginRequired &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", null,
                                        React.createElement("span", { className: styles.countdownMessageDesc }, sisfoOrderCMS === null || sisfoOrderCMS === void 0 ? void 0 : sisfoOrderCMS.preOrderMessage)),
                                    React.createElement(Button, { testId: getTestId('Link', 'LOGIN_LINK'), data: { text: 'Sign in' }, options: { className: styles.countdownMessageLoginBtn }, events: {
                                            onClick: function () {
                                                _this.loginLinkClicked(redirectionURL);
                                            },
                                        } }))))));
        }
        return (React.createElement(React.Fragment, null));
    };
    CartCheckoutCountDownTimer.prototype.checkIntervals = function () {
        var _this = this;
        var count = 0;
        var intervalTimer = window.setInterval(function () {
            var _a, _b, _c, _d;
            var cmsTime = Date.parse((_d = (_c = (_b = (_a = _this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.common) === null || _c === void 0 ? void 0 : _c.sisfoOrder) === null || _d === void 0 ? void 0 : _d.preOrderEndTime);
            var currentTime = Date.now();
            var cmsTimeAfter = cmsTime + 1000;
            var cmsTimeBefore = cmsTime - 1000;
            var isCurrentTimeSlot = cmsTimeBefore < currentTime && cmsTimeAfter > currentTime;
            if (count === 0 && isCurrentTimeSlot && cartUtils.isAtleastOneLineLevelPrePreOrderIndicator()) {
                console.log('Timer condition satisfied with count ' + count);
                console.log('Current Time is' + currentTime);
                console.log('CMS time is ' + cmsTime);
                window.clearInterval(intervalTimer);
                _this.checkoutApi.initialiseCart().then(function () {
                    count++;
                    _this.stateManager.set('cartUpdate', { cartRefresh: true });
                }).catch(function (err) {
                    count++;
                    console.log('Error in Initialize cart');
                });
            }
        }, 1000);
    };
    CartCheckoutCountDownTimer.prototype.loginLinkClicked = function (redirectionUrl) {
        this.reportingService.fireLinkClickWithOutPageLoad('Sign in', PageUrls.CART);
        if (redirectionUrl && typeof window !== undefined) {
            window.location.href = redirectionUrl;
        }
    };
    return CartCheckoutCountDownTimer;
}(React.Component));
export default CartCheckoutCountDownTimer;
//# sourceMappingURL=CartCheckoutCountDownTimer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/CartCheckoutCountDownTimer.js
// module id = 977
// module chunks = 8